export const PAYG_SECOND_PAGE_FAQ_TITLE = 'Frequently Asked Questions';

export const PAYG_SECOND_PAGE_FAQ_DESCRIPTION = 'Everything you need to know about our pricing and plans';

export const PAYG_SECOND_PAGE_FAQ_DATA = [
  {
    id: 'annual-billing-discounts',
    question: 'Do you offer annual billing discounts?',
    answer:
      'Yes. You can toggle between monthly and yearly billing at the top of the pricing page. Annual plans offer significant savings compared to monthly billing. Enterprise pricing is customized based on your usage requirements and is typically structured as an annual contract.',
    default_opened: true,
  },
  {
    id: 'unlimited-company-verifications',
    question: 'What does "unlimited company verifications" mean?',
    answer:
      'Company verification confirms a business exists and is registered with official government registries. Accelerate and Enterprise users can run unlimited verifications for KYB (Know Your Business) compliance, vendor due diligence, or customer onboarding without usage caps.',
    internationalizations: ['payg_pipeline'],
  },
  {
    id: 'email-sequences-limits',
    question: 'How do email sequences and daily sending limits work?',
    answer:
      'Growth allows 100 emails per day across 2 sequences from 1 mailbox. Accelerate removes daily limits and lets you run up to 10 sequences across 10 mailboxes on 5 domains. This scales your outbound without deliverability issues from overloading a single inbox.',
    internationalizations: ['payg_pipeline'],
  },
  {
    id: 'data-source',
    question: 'Where does your data come from?',
    answer:
      "We source data directly from over 200 official government registries worldwide. This means you're getting verified, first-party information rather than aggregated or resold data. Our coverage spans 600+ million companies across 200+ countries.",
  },
  {
    id: 'crm-integrations',
    question: 'What CRM integrations are available?',
    answer:
      'We offer integration with Salesforce, HubSpot, and Microsoft Dynamics. These sync company and contact data directly into your CRM. Growth and Accelerate users can export data manually or use our web extension for browser-based workflows.',
  },
  {
    id: 'system-integration',
    question: 'Can I integrate your data into my systems?',
    answer:
      'Yes. Enterprise plans include full API access, bulk data feeds, and native integrations with Salesforce, HubSpot, and Microsoft Dynamics. You can embed our data directly into your CRM, compliance workflows, or proprietary applications. We also offer internal and external licensing rights for teams that need to redistribute data within their organization or to clients.',
  },
  {
    id: 'global-corporate-linkage',
    question: 'What\'s included in "Global Corporate Linkage"?',
    answer:
      'Global Corporate Linkage maps parent-subsidiary relationships across jurisdictions. You can trace ownership structures from a local entity up to the ultimate parent company, identify sister companies, and understand complex multinational hierarchies. Essential for compliance, risk assessment, and enterprise account mapping.',
  },
  {
    id: 'data-update-frequency',
    question: 'How often is your data updated?',
    answer:
      'We continuously sync with official government registries worldwide. Update frequency varies by registry — some update daily, others weekly or monthly based on how the source publishes new filings. Critical changes like company status, director appointments, and ownership transfers are captured as soon as registries publish them.',
  },
  {
    id: 'platform-reliability',
    question: 'How reliable is Global Database?',
    answer:
      'Our platform maintains 99.9% uptime with enterprise-grade infrastructure. Data reliability comes from our direct connection to 100+ official government registries. Enterprise clients including Uber, AWS, WeWork, SAP, and LSEG trust us for mission-critical compliance and business intelligence workflows.',
  },
  {
    id: 'payment-security',
    question: 'How secure is my payment information?',
    answer:
      'We use Stripe as our merchant provider. Your card details are never stored on our servers. All transactions are processed through secure, encrypted connections.',
  },
  {
    id: 'gdpr-compliance',
    question: 'How does Global Database handle GDPR compliance?',
    answer:
      'Our company data comes from official public registries, which is legitimate interest under GDPR. For contact data, we follow strict compliance protocols including data subject access requests and right-to-erasure procedures. We provide Data Processing Agreements (DPAs) for Enterprise clients and maintain documentation for audit purposes.',
  },
  {
    id: 'cancel-upgrade-subscription',
    question: 'Can I cancel or upgrade my subscription?',
    answer:
      "Yes. Upgrade from Growth to Accelerate anytime — premium features activate immediately. Cancel monthly plans whenever you want; you'll retain access until your billing period ends. Downgrades take effect at your next billing cycle. Enterprise plan changes are handled through your dedicated account manager.",
  },
  {
    id: 'pricing-per-user-team',
    question: 'Is pricing per user or per team?',
    answer:
      'Growth and Accelerate are priced per user, per month. Each team member needs their own seat. Enterprise offers flexible pricing that can include unlimited seats, depending on your agreement. Contact sales to discuss team-based pricing.',
  },
  {
    id: 'payment-methods',
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit cards for Growth and Accelerate plans. Enterprise customers can pay via invoice with NET 30 terms. Annual plans can be paid upfront or in installments depending on contract value.',
  },
  {
    id: 'refunds',
    question: 'Do you offer refunds?',
    answer:
      "We offer a satisfaction guarantee on annual Accelerate plans. If you're not seeing value within the first 30 days, contact support to discuss your options. Monthly plans can be cancelled anytime and won't renew. Enterprise refund terms are specified in your contract.",
  },
  {
    id: 'end',
    closable: false,
    question: 'Still Have Questions?',
    answer: 'Our team is ready to help you find the right plan. Contact us at support@globaldatabase.com.',
  },
];
